<template>
  <div class="BC-container">

    <div class="BC-right-container">
      <div>
        <h3>配件条形码打印：</h3>
        <p align="middle" style="margin-top: 20px">
          批量生成适用于
          <el-select
            filterable
            v-model="applicableModels"
            placeholder="适用机型"
            style="width: 160px; height: 25px"
            v-el-select-loadmore="selectLoadMoreSnInfo"
            size="small"
          >
            <el-option
              v-for="(data, index) in Array.from(new Set(this.phoneNameList))"
              :key="index"
              :value="data"
              :label="data"
            ></el-option> </el-select
          >的
          <el-select
            v-model="fitType"
            placeholder="配件类型"
            style="width: 100px; height: 25px"
            size="small"
          >
            <el-option
              v-for="(data, index) in options"
              :key="index"
              :value="data"
              :label="data"
            ></el-option>
          </el-select>
          条形码
          <el-input
            v-model="barCodeNum"
            style="width: 80px"
            size="mini"
          ></el-input
          >份
        </p>
        <div class="tipsDemo">
          {{ tips }}
        </div>
        <el-row style="margin-top: 20px">
          <el-button
            @click="submitBarcodeNum()"
            :disabled="isButtonDisabled"
            type="primary"
            size="small"
            >批量生成条形码</el-button
          >
          
        </el-row>
        <el-row style="margin-top: 20px">
          <el-button @click="obtainBarcodeInformation" type="primary" size="small"
            >条形码打印</el-button
          >
        </el-row>
        <el-row style="margin-top: 20px">
          <el-button @click="submitScanInData" type="primary" size="small"
            >入库</el-button
          >
        </el-row>
        <el-row style="margin-top: 20px">
          <el-button @click="print(barcodePrintData)" type="primary" size="small"
            >打印</el-button
          >
        </el-row>
        
      </div>
    </div>
    <el-dialog
      title="入库"
      :visible.sync="warehousingVisible"
      width="50%"
      :before-close="handleClose"
    >
      <div>
        <el-input type="textarea" :rows="12" v-model="scanBarcodeIn"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="warehousingVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitScanInData">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import Socket from "@/utils/Socket";
import NMPrintSocket from "@/utils/Print";
import { batchPrintData } from "@/utils/printData/Batch";
import { barcodePrintData } from "@/utils/printData/Barcode";
export default {
  //创建自定义事件
  directives: {
    "el-select-loadmore": {
      bind(el, binding) {
        const SELECTWRAP_DOM = el.querySelector(
          ".el-select-dropdown .el-select-dropdown__wrap"
        );
        SELECTWRAP_DOM.addEventListener("scroll", function () {
          const rect = this.getBoundingClientRect();
          const isAtBottom = rect.bottom <= window.innerHeight;
          if (isAtBottom) {
            binding.value();
          }
        });
      },
    },
  },
  data() {
    const jsonObj = {
      printerImageProcessingInfo: {
        printQuantity: 1,
      },
    };
    return {
      isButtonDisabled:false,
      tips: '',
      items: [],
      newItem: "",
      fitType: "",
      applicableModels: "",
      fitTypePrint: "",
      barCodeNum: "",
      warehousingVisible: false,
      scanBarcodeIn:[],
      jsonObj,
      // 打印服务是否连接成功
      printSocketOpen: false,
      batchPrintData,
      barcodePrintData,
      barCodeList: [],
      barCodePrintList: [],
      barcodePrintFlag: false,
      nMPrintSocket: null,
      usbPrinters: {},
      usbSelectPrinter: "",
      onlineUsbBool: false,
      initBool: false,
      responseflag: false,
      density: 3,
      label_type: 1,
      print_mode: 1,
      options: [],
      phoneNameList: [],
      currentPage: 1,
      pageSize: 200,
      isExist:0
    };
  },
  mounted() {
    // 创建socket实例
    const socketData = new Socket("ws://127.0.0.1:37989");

    socketData.open(
      (openBool) => {
        console.log(openBool, "openBool");
        this.printSocketOpen = openBool;
      },
      (msg) => {
        if (msg.resultAck.callback != undefined) {
          const callbackName = msg.resultAck.callback.name;
          const msgInfo = msg.resultAck.info;
          if (callbackName == "onCoverStatusChange") {
            //盒盖状态：0-闭合、1-打开
            console.log("盒盖状态", msgInfo.capStatus);
          } else if (callbackName == "onElectricityChange") {
            //"power" : 0-4, // 电池电量等级（共5档）
            console.log("电池电量等级", msgInfo.power);
          }
        }
      }
    );
    // 创建打印实例
    this.nMPrintSocket = new NMPrintSocket(socketData);
  },
  created() {
    this.obtainPJInfo();
    this.obtainPhoneInfo();
  },
  methods: {
    printTest(){
      console.log('下一步打印')
    },
    async print(content) {
      const allPrintersRes = await this.nMPrintSocket.getAllPrinters();
      console.log(allPrintersRes, "allPrintersRes");
      try {
        // const { errorCode, info } = JSON.parse(JSON.stringify(data)).resultAck;
        if (allPrintersRes.resultAck.errorCode === 0) {
          const allPrinters = JSON.parse(allPrintersRes.resultAck.info);
          const allPrintersName = Object.keys(allPrinters);
          const allPrintersValue = Object.values(allPrinters);
          console.log(allPrinters, "allPrinters");
          console.log(
            allPrintersName[0],
            allPrintersValue[0],
            "allPrintersName[0]",
            "allPrinters[0]"
          );
          const res = await this.nMPrintSocket.selectPrinter(
            allPrintersName[0],
            parseInt(allPrintersValue[0])
          );
          console.log("选择打印机", res);

          if (res.resultAck.errorCode === 0) {
            console.log("连接成功");
            const initRes = await this.nMPrintSocket.initSdk({ fontDir: "" });
            if (initRes.resultAck.errorCode == 0) {
              console.log("初始化成功");
              this.startBatchPrintJobTest(content);
            } else {
              console.log("初始化失败");
            }
          } else {
            console.log("连接失败");
            alert("连接失败");
          }
        } else {
          return alert("没有在线的打印机");
        }
      } catch (err) {
        return alert(err);
      }
    },
    
    // 下拉列表触底事件
    selectLoadMoreSnInfo() {
      console.log("下拉框到底触发");
      this.currentPage += 1;
      this.obtainPhoneInfo();
    },

    obtainPhoneInfo() {
      axios({
        method: "post",
        url: "/openApi/app/5u91so0k1801/apply/filter",
        data: {
          pageSize: this.pageSize,
          pageNum: this.currentPage,
        },
        headers: {
          "Content-Type": "application/json",
          accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
        },
        withCredentials: true,
      })
        .then((res) => {
          res.data.result.result.forEach((element) => {
            element.answers.forEach((item) => {
              if (item.queId == "182383247") {
                this.phoneNameList.push(item.values[0].dataValue);
              }
            });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //更新打印机列表
    async getPrinters() {
      if (!this.printSocketOpen) {
        return alert("打印服务未开启");
      }
      console.log("开始获取打印机");
      try {
        const allPrintersRes = await this.nMPrintSocket.getAllPrinters();
        console.log(allPrintersRes, "allPrintersRes");
        if (allPrintersRes.resultAck.errorCode === 0) {
          const allPrinters = JSON.parse(allPrintersRes.resultAck.info);
          this.usbPrinters = { ...allPrinters };
          this.usbSelectPrinter = Object.keys(this.usbPrinters)[0];
          console.log("printers", this.usbPrinters);
        } else {
          alert("没有在线的打印机");
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 连接打印机
    async selectOnLineUsbPrinter() {
      if (!this.printSocketOpen) {
        return alert("打印服务未开启");
      }
      console.log("开始连接打印机");
      try {
        const res = await this.nMPrintSocket.selectPrinter(
          this.usbSelectPrinter,
          parseInt(this.usbPrinters[this.usbSelectPrinter])
        );
        console.log("选择打印机", res);

        if (res.resultAck.errorCode === 0) {
          console.log("连接成功");
          this.onlineUsbBool = true;
        } else {
          console.log("连接失败");
          this.onlineUsbBool = false;
          alert("连接失败");
        }
      } catch (err) {
        console.error(err);
      }
    },
    //初始化SDK
    async init() {
      if (!this.printSocketOpen) return alert("打印服务未开启");
      //初始化数据
      try {
        const res = await this.nMPrintSocket.initSdk({ fontDir: "" });
        if (res.resultAck.errorCode == 0) {
          console.log("初始化成功");
          this.initBool = true;
        } else {
          console.log("初始化失败");
          this.initBool = false;
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 开始批量打印
    async startBatchPrintJobTest(content) {
      console.log(content, "content.data");
      console.log(content.length, "content.data");
      // console.log(this.batchPrintData.data,'batchPrintData')
      // this.batchPrintData.data = content
      if (!this.printSocketOpen) return alert("打印服务未开启");
      if (content == null || content.length == 0) {
        return;
      }
      // let contentArr = [];
      // contentArr.push(content);
      // this.batchPrintJob(contentArr);
      this.batchPrintJob(content);
      // this.batchPrintJob(content);
    },
    //批量打印列表数据
    async batchPrintJob(list) {
      console.log(list.length, "打印份数");
      const printQuantity =
        this.jsonObj.printerImageProcessingInfo.printQuantity;
      try {
        const startRes = await this.nMPrintSocket.startJob(
          this.density,
          this.label_type,
          this.print_mode,
          list.length * printQuantity
        );
        if (startRes.resultAck.errorCode == 0) {
          // 提交打印任务
          await this.printTag(list, 0);
        }
      } catch (err) {
        console.error(err);
      }
    },
    // 绘制打印标签
    async printTag(list, x) {
      console.log(list, x);
      //设置画布尺寸
      try {
        const res = await this.nMPrintSocket.InitDrawingBoard(
          list[x].InitDrawingBoardParam
        );
        if (res.resultAck.errorCode != 0) {
          return;
        }
        // 提交打印任务
        this.printItem(list, x, list[x].elements, 0);
      } catch (err) {
        console.error(err);
      }
    },
    async printItem(list, x, item, i) {
      try {
        if (i < item.length) {
          let arrParse;
          switch (item[i].type) {
            case "text":
              //绘制文本
              arrParse = await this.nMPrintSocket.DrawLableText(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
            case "qrCode":
              arrParse = await this.nMPrintSocket.DrawLableQrCode(item[i].json);
              //绘制二维码
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
            case "barCode":
              //绘制一维码
              arrParse = await this.nMPrintSocket.DrawLableBarCode(
                item[i].json
              );
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item);
              break;
            case "line":
              //绘制线条
              arrParse = await this.nMPrintSocket.DrawLableLine(item[i].json);
              if (arrParse.resultAck.errorCode !== 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
            case "graph":
              //绘制边框
              arrParse = await this.nMPrintSocket.DrawLableGraph(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }

              i++;
              await this.printItem(list, x, item, i);
              break;
            case "image":
              //绘制边框
              arrParse = await this.nMPrintSocket.DrawLableImage(item[i].json);
              if (arrParse.resultAck.errorCode != 0) {
                return;
              }
              i++;
              await this.printItem(list, x, item, i);
              break;
          }
        } else {
          //遍历完成，开始打印
          const commitRes = await this.nMPrintSocket.commitJob(
            null,
            JSON.stringify(this.jsonObj)
          );
          //回调页码为数据总长度且回调打印份数数据等于当前页需要打印的份数数据时，结束打印任务
          if (
            commitRes.resultAck.printQuantity == list.length &&
            commitRes.resultAck.onPrintPageCompleted ==
              this.jsonObj.printerImageProcessingInfo.printQuantity
          ) {
            //结束打印任务
            const endRes = await this.nMPrintSocket.endJob();
            if (endRes.resultAck.errorCode === 0) {
              console.log("打印完成");
              this.submitScanInData()

            }
            return;
          }
          //回调为提交成功，同时数据未发送完成时，可继续提交数据
          if (commitRes.resultAck.errorCode === 0 && x < list.length - 1) {
            //数据提交成功，数据下标+1
            console.log("发送下一页打印数据： ");
            x++;
            await this.printTag(list, x);
          }
        }
      } catch (err) {
        console.error(err,'打印出错ERR');
      }
    },
    submitBarcodeNum() {
      var that = this;
      let tables = [];    
      //检查是否有未入库的数据
      axios({
        method: "post",
        url: "openApi/app/6a6t22c42002/apply/filter",
        data: {
          pageSize: 50,
          pageNum: 1,
          queries:[
            {
              "queId": 182390635,
              "searchKey": "否"
            }
          ]
        },
        headers: {
          "Content-Type": "application/json",
          accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
          // 'Cookie' header should not be set in client-side JavaScript due to security reasons
        },
        // If withCredentials is true, server must echo back the exact value of the Origin request header in the Access-Control-Allow-Origin response header
        withCredentials: true,
      }).then((res) => {
        console.log("获取入库数据",res);
        if(res.data.result.pageAmount > 0){
          Vue.set(that.isExist,'e',res.data.result.pageAmount)
          console.log("有未入库的");
          return;
        }
      })
      //这里我不知道为什么赋值不了，我的逻辑是如果存在未入库的数据，那么下面的代码就不需要进行了，直接中断方法,并且弹出提示，有未入库的标签，请先入库
      console.log("是否存在",that.isExist);

      for (let i = 0; i < that.barCodeNum; i++) {
        let value = [];
        value.push({
          queId: 182395554,
          queTitle: "配件名称",
          queType: 2,
          values: [
            { dataValue: that.fitType, queId: 182395554, value: that.fitType },
          ],
        });
        tables.push(value);
      }
      console.log(JSON.stringify(tables));

      let data = [];
      data.push({
        queId: 182394194,
        queTitle: "配件类型",
        queType: 2,
        values: [{ value: that.fitType }],
      });
      data.push({
        queId: 182394195,
        queTitle: "打印份数",
        queType: 2,
        values: [{ value: that.barCodeNum }],
      });
      data.push({
        queId: 182394901,
        queTitle: "适用机型",
        queType: 2,
        values: [{ value: that.applicableModels }],
      });
      data.push({
        queId: 182395553,
        queTitle: "自动计算",
        queType: 18,
        tableValues: tables,
      });
      console.log(JSON.stringify(data));
      axios({
        method: "post",
        url: "openApi/app/6lnksu903k02/apply",
        data: {
          answers: data,
        },
        headers: {
          "Content-Type": "application/json",
          accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
        },
        withCredentials: true,
      })
        .then((res) => {
          that.$notify({
            title: "请求成功",
            message: "提交条形码信息成功",
            type: "success",
          });
          that.newItem =
            "已生成适用于" +
            that.applicableModels +
            "的" +
            that.fitType +
            that.barCodeNum +
            "份";
          that.tips = that.newItem;
          console.log(res, "res");
          // this.obtainBarcodeInformation();
          that.isButtonDisabled = true
          that.fitType = ''
          that.applicableModels = ''
          that.barCodeNum = ''
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async obtainBarcodeInformation() {
      var that = this;
      that.barCodePrintList = [];
      that.scanBarcodeIn = []
      axios({
        method: "post",
        url: "openApi/app/6a6t22c42002/apply/filter",
        data: {
          pageSize: 999999,
          pageNum: 1,
          queries:[
            {
              "queId": 182390622,
              "searchKey": "否"
            }
          ]

        },
        headers: {
          "Content-Type": "application/json",
          accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
        },
        withCredentials: true,
      })
        .then((res) => {
          that.$notify({
            title: "请求成功",
            message: "获取条形码信息成功",
            type: "success",
          });
          console.log(res, "obtainBarcodeInformation");
          that.barCodeList = res.data.result.result;
          console.log(that.barCodeList,'获取到的数据')
          if(that.barCodeList.length == 0){
            console.log('结束打印')
          }else{
              try{
              // for (var i = 0; i < length; i++) {
              // console.log(i, "-----i----");
              let item = that.barCodeList[0].answers;
              // 首先检查是否存在queId等于182383150且dataValue等于"在库"的项目
              const isInStorage = item.some(
                (answer) =>
                  answer.queId === 182390635 &&
                  answer.values.some((value) => value.dataValue == "否")
              );
              // console.log(value)
              // 如果存在，再提取所有queId等于0的dataValue的值
              let values = [];
              if (isInStorage) {
                values = item
                  .filter((answer) => answer.queId === 0)
                  .flatMap((answer) =>
                    answer.values.map((value) => value.dataValue)
                  );
              }
              // console.log(values[0], "values"); // 输出符合条件的编号dataValue的值
              let codeValue = values[0];
              // let PJnameValues = [];
              console.log(codeValue, "codeValue");
              that.scanBarcodeIn.push(codeValue)
              console.log(that.scanBarcodeIn,'that.scanBarcodeIn---1')
              if (isInStorage) {
                values = item
                  .filter((answer) => answer.queId === 182394410)
                  .flatMap((answer) =>
                    answer.values.map((values) => values.dataValue)
                  );
              }
              let PJnameValue = values[0];
              console.log(PJnameValue, "PJnameValue"); // 输出符合条件的配件名称dataValue的值
              if (isInStorage) {
                values = item
                  .filter((answer) => answer.queId === 182394902)
                  .flatMap((answer) =>
                    answer.values.map((values) => values.dataValue)
                  );
              }
              let PJApplication = values[0];
              // console.log(PJApplication, "PJApplication"); // 输出符合条件的配件适用机型dataValue的值
              if (codeValue !== undefined) {
                console.log("这里了");
                const printbarData = {
                  InitDrawingBoardParam: {
                    width: 40,
                    height: 30,
                    rotate: 0,
                    path: "ZT001.ttf",
                    verticalShift: 0,
                    HorizontalShift: 0,
                  },

                  elements: [
                    {
                      type: "text",
                      json: {
                        x: 2,
                        y: 2,
                        height: 4.3,
                        width: 34,
                        value: "数据线",
                        codeType: 20,
                        rotate: 0,
                        fontSize: 2.6,
                        textHeight: 3.2,
                        textPosition: 0,
                      },
                    },
                    {
                      type: "barCode",
                      json: {
                        x: 2,
                        y: 8,
                        height: 15,
                        width: 30,
                        value: "00001",
                        codeType: 20,
                        rotate: 0,
                        fontSize: 3.2,
                        textHeight: 3.2,
                        textPosition: 0,
                      },
                    },
                  ],
                };
                if(PJApplication == undefined){
                  printbarData.elements[0].json.value = PJnameValue;
                }else{
                  printbarData.elements[0].json.value = PJApplication + PJnameValue;
                }
                printbarData.elements[1].json.value = codeValue;
                console.log(printbarData,'that.printbarData')
                that.barCodePrintList.push(printbarData);
                that.print(that.barCodePrintList)
            }
            }catch (error) {
              console.error('An error occurred while printing:', error);
            } 
          }     
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    toWarehousing() {
      this.warehousingVisible = true;
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    submitScanInData() {
      var that = this;
      // that.scanBarcodeIn = []
      console.log(that.scanBarcodeIn, "-------scanBarcodeIn---------");
      axios({
        method: "post",
        url: "openApi/app/6a6t22c42002/apply/filter",
        data: {
          pageSize: 200,
          pageNum: 1,
          queries:[
            {
              "queId": 182390622,
              "searchKey": "否"
            }
          ]
        },
        headers: {
          "Content-Type": "application/json",
          accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
        },
        withCredentials: true,
      })
        .then((res) => {
          console.log(res, "res");
          let applyIdList = res.data.result.result;
          // console.log(applyIdList, "---applyIdList");
          for (var i = 0; i < applyIdList.length; i++) {
            // console.log(applyIdList[i], "-----item----");
            // console.log(applyIdList[i].applyId, "-----applyId----");
            let oneApplyID = applyIdList[i].applyId;
            let answersList = applyIdList[i].answers;
            for (var index = 0; index < answersList.length; index++) {
              // console.log(answersList[index], "answer");
              if (answersList[index].queId == 0) {
                
                if (that.scanBarcodeIn.includes(answersList[index].values[0].value)) {
                  console.log("元素在扫描到的数组中");
                  axios({
                    method: "post",
                    url: "openApi/apply/" + oneApplyID,
                    data: {
                      answers: [
                        { queId: 182390622, values: [{ value: "是" }] },
                        { queId: 182390635, values: [{ value: "是" }] },
                      ],
                    },
                    headers: {
                      accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
                      "Content-Type": "application/json",
                    },
                    withCredentials: true,
                  })
                    .then((response) => {
                      console.log(response);
                      that.isButtonDisabled = false;
                      that.obtainBarcodeInformation()

                    })
                    .catch(function (error) {
                      console.log(error);
                    });
                } else {
                  console.log("元素不在扫描到的数组中");
                }
              }
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    obtainPJInfo() {
      this.options = [];
      axios({
        method: "post",
        url: "openApi/app/6lnic53k3k01/apply/filter",
        data: {
          pageSize: 50,
          pageNum: 1,
        },
        headers: {
          "Content-Type": "application/json",
          accessToken: "62b6c5b8-dd44-4f4e-8f95-865d45189bb3",
        },
        withCredentials: true,
      })
        .then((res) => {
          res.data.result.result.forEach((element) => {
            element.answers.forEach((item) => {
              if (item.queId == "182394186") {
                this.options.push(item.values[0].dataValue);
              }
            });
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.BC-container{
    display: flex;
    width: 100%;
    height: 700px;
}
.BC-left-container {
  background-color: #d9ecff;
  width: 48%;
  margin: 25px;
  padding: 2%;
  border-radius: 20px;
}
.BC-right-container {
  /* background-color:  #d9ecff; */
  width: 98%;
  margin: 25px;
  padding: 2%;
  border-radius: 20px;
}
h3 {
  text-align: left;
}
.tipsDemo {
  /* background-color: #f0f9eb; */
  color: #67c23a;
}
.el-button--primary {
  color: #fff;
  background-color: #fb9337;
  border-color: #fb9337;
}
.el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
    color: #FFF;
    background-color: #f3d19e;
    border-color: #f3d19e;
}
</style>


// WEBPACK FOOTER //
// src/views/SNPageTest.vue